import Welcome from "@/modules/welcome/pages/Welcome.vue";
import TermsOfService from "@/modules/welcome/pages/TermsOfService.vue";

export default [
  {
    path: "/welcome",
    name: "welcome",
    component: Welcome,
  },
  {
    path: "/terms-of-service",
    name: "termsOfService",
    component: TermsOfService,
  },
];
